import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: _ctx.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeName = $event)),
    class: "pc-system-tab",
    onTabClick: _ctx.getTabVal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: "门户微页面",
        name: "Pagelist"
      }),
      _createVNode(_component_el_tab_pane, {
        label: "导航设置",
        name: "NavBarSetting"
      }),
      _createVNode(_component_el_tab_pane, {
        label: "页脚设置",
        name: "FooterSetting"
      }),
      _createVNode(_component_el_tab_pane, {
        label: "风格与其他",
        name: "PageStyle"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onTabClick"]))
}